import UbsApiV2 from "./UbsApiV2";
export const getBlocksByLocationAndBlockDate = async (
  locationId,
  blockDate
) => {
  const response = await UbsApiV2.get(`/ssc/calendar/blocks`, {
    // headers: headers,
    params: {
      location_id: locationId,
      block_date: blockDate,
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errRes = {};
      if (err.response !== undefined) {
        errRes = err.response;
      } else {
        errRes = "Network error";
      }
      return errRes;
    });
  return response;
};

export const createBlock = async (body) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const response = await UbsApiV2.post(`/ssc/calendar/blocks`, body, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return response;
};

export const updateBlock = async (uuid, body) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const response = await UbsApiV2.put(`/ssc/calendar/blocks/${uuid}`, body, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return response;
};

export const updateStatusBlock = async (uuid, action) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await UbsApiV2.patch(
    `/ssc/calendar/blocks/${uuid}/${action}`,
    {
      headers: headers,
    }
  )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return response;
};
